<template>
    <div>
        <div>
            <pc-filtered-select
                id="AddAttachmentSelector"
                v-model="attachmentIdToAdd"
                data-test-role="AddAttachmentSelector"
                v-bind:label="addAttachmentDialogSelectLabel"
                v-bind:items="availableAttachments"
                v-bind:validator="addAttachmentValidator"
                v-bind:placeholder-text="addAttachmentDialogSelectDefaultText"
                v-bind:format-for-modal="true"
                text-prop="Name"
                value-prop="PublicId"
                v-on:validated="onAddAttachmentValidated">
            </pc-filtered-select>
        </div>
        <pc-alert
            v-if="isTemplateMode"
            class="mt-3 mb-0"
            v-bind="attachmentAlertBinder">
            <div>
                <div v-if="showUnsupportedExtensionsWarning">
                    <b>{{ noteLabel }}</b>
                    <span>{{ unsupportedExtensionsWarningText }}</span>
                    <span>{{ unsupportedExtensionsText }}</span>
                </div>
                <div
                    v-if="showAllowsLargeFilesWarning"
                    v-bind:class="showUnsupportedExtensionsWarning ? 'mt-3' : ''">
                    <b>{{ noteLabel }}</b>
                    <span> {{ largeFileWarningText }}</span>
                </div>
            </div>
        </pc-alert>
    </div>
</template>
<script>
    import { NAMESPACE, KEYS } from "./i18n/addAttachmentDialog.i18n";
    import { mapI18n } from "Util/i18n";
    import { ALERT_SEVERITY } from "Util/alerts";
    import { DIALOG_HOOK, DIALOG_RESULT } from "Components/pc-dialog.vue";

    export default {
        props: {
            isTemplateMode: { type: Boolean, required: false, default: false },
            availableAttachments: { type: Array, required: true },
            addAttachmentValidator: { type: Object, required: false, default: null }
        },
        data() {
            return {
                attachmentIdToAdd: null,
                addAttachmentValidationResult: null
            };
        },
        computed: {
            canAddAttachment() {
                return Boolean(this.attachmentIdToAdd) && !this.hasAddAttachmentError;
            },
            hasAddAttachmentError() {
                return this.addAttachmentValidationResult && this.addAttachmentValidationResult.hasError;
            },
            attachmentToAdd() {
                if (!this.attachmentIdToAdd) {
                    return null;
                }
                return this.availableAttachments.find((ad) => ad.PublicId === this.attachmentIdToAdd);
            },
            showUnsupportedExtensionsWarning() {
                if (!this.isTemplateMode) {
                    return false;
                }
                return Boolean(
                    this.attachmentToAdd && this.attachmentToAdd.AttachmentDefinitionUnsupportedExtensions.length > 0
                );
            },
            unsupportedExtensionsText() {
                if (!this.showUnsupportedExtensionsWarning) {
                    return null;
                }
                return `[${this.attachmentToAdd.AttachmentDefinitionUnsupportedExtensions.join(", ")}]`;
            },
            showAllowsLargeFilesWarning() {
                if (!this.isTemplateMode) {
                    return false;
                }
                return Boolean(this.attachmentToAdd && this.attachmentToAdd.AttachmentDefinitionAllowsLarge);
            },
            showAttachmentAlert() {
                return (
                    this.isTemplateMode && (this.showUnsupportedExtensionsWarning || this.showAllowsLargeFilesWarning)
                );
            },
            attachmentAlertBinder() {
                return {
                    shown: this.showAttachmentAlert,
                    severity: ALERT_SEVERITY.info,
                    transition: "fade"
                };
            },
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        },
        methods: {
            onAddAttachmentValidated(result) {
                this.addAttachmentValidationResult = result;
            },
            [DIALOG_HOOK.getResult](result) {
                if (result === DIALOG_RESULT.cancel) {
                    return null;
                }
                return this.attachmentIdToAdd;
            },
            [DIALOG_HOOK.isValidToClose](result) {
                if (result === DIALOG_RESULT.cancel) {
                    return true;
                }
                return this.canAddAttachment;
            }
        }
    };
</script>
